import {
    FETCH_REBATE_DATA,
    SET_REBATE_DATA,
    RESET_REBATE_DATA,
} from '../actionTypes/RebatesActionTypes';

export const fetchRebateData = (payload) => ({
    type: FETCH_REBATE_DATA,
    payload,
});

export const setRebateData = () => ({
    type: SET_REBATE_DATA,
});

export const resetRebateData = () => ({
    type: RESET_REBATE_DATA,
});
